import React, { useEffect, useState } from 'react';

const LINKS = [
  { href: '#portfolio', label: 'Work' },
  { href: '#services', label: 'Services' },
  { href: '#about', label: 'How we work' },
];

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setIsScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const closeMenu = () => setIsOpen(false);

  return (
    <header className={`header${isScrolled || isOpen ? ' header--solid' : ''}`}>
      <a href="#top" className="header-logo" onClick={closeMenu}>
        <img src={`${process.env.PUBLIC_URL}/omnistrix-wordmark-light.png`} alt="Omnistrix" width="1341" height="270" />
      </a>
      <button
        type="button"
        className="menu-toggle"
        aria-expanded={isOpen}
        aria-controls="site-nav"
        onClick={() => setIsOpen(!isOpen)}
      >
        {isOpen ? 'Close' : 'Menu'}
      </button>
      <nav id="site-nav" className={`nav${isOpen ? ' nav--open' : ''}`} aria-label="Main">
        {LINKS.map((link) => (
          <a key={link.href} href={link.href} onClick={closeMenu}>{link.label}</a>
        ))}
        <a href="#contact" className="btn btn-small" onClick={closeMenu}>Book a consult</a>
      </nav>
    </header>
  );
};

export default Header;
